/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Coinvestments_Lpdealoverviewcontent_Add4Inputs */

const en_coinvestments_lpdealoverviewcontent_add4 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Add4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add ${i?.type}`)
};

/**
* | output |
* | --- |
* | "Add {type}" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Add4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_add4 = /** @type {((inputs: Coinvestments_Lpdealoverviewcontent_Add4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Add4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_add4(inputs)
});
export { coinvestments_lpdealoverviewcontent_add4 as "coInvestments_lpDealOverviewContent_add" }